import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import sounds from 'src/lib/sounds';
import LockedButtonOverlay from '../components/LockedButtonOverlay';
import { Feature } from 'src/replicant/analytics';
import { openPopupPromise } from 'src/lib/popups/popupOpenClose';
import { daycareEntrySequence } from './daycare.sequence';
import { DaycareAvailabilityResult } from 'src/replicant/daycare';
import { LockedReason } from '../popups/PopupFeatureDisabled';
import { assertNever } from 'src/replicant/utils';
import { getDaycareId } from '../../replicant/daycare/daycare.getters';
import { user } from '../../StateObserver';

const style = {
  ...uiConfig.buruburu,

  // Inherit base style from care action buttons with daycare icon
  icon: {
    ...uiConfig.buruburu.care.actionIcons.snack,
    image: 'assets/ui/daycare/icons/care_action_daycare_icon.png',
  },
};

export default class DaycareActionButton extends ButtonScaleViewWithText {
  constructor(private opts: DaycareAvailabilityResult) {
    super({
      ...style.menu.menuButton,
      icon: style.icon,
      localeText: () => i18n('daycare.action'),
      tracking: {
        feature: Feature.DAYCARE._,
        $subFeature: Feature.DAYCARE.ACTION,
      },
    });

    this.icon!.updateOpts({ scaleMethod: 'contain' });

    if (!opts.isAvailable) {
      const { width, height } = this.style;
      this.addSubview(new LockedButtonOverlay({ width, height }));
    }
  }

  public onClick = async () => {
    sounds.sfx.play('ok');

    if (this.opts.isAvailable === false) {
      await openPopupPromise('popupFeatureDisabled', {
        feature: 'daycare',
        reason: getLockedReason(this.opts.reason),
        origin: 'hud',
      });
      return;
    }

    const daycareId = getDaycareId();
    const confirmed = await openPopupPromise('popupConfirmDaycare', {
      daycareId,
      origin: 'hud',
    });

    if (confirmed) {
      await daycareEntrySequence(daycareId);
    }
  };
}

type DaycareUnavailableReason = Extract<
  DaycareAvailabilityResult,
  { isAvailable: false }
>['reason'];

function getLockedReason(
  reason: DaycareUnavailableReason,
): LockedReason | undefined {
  switch (reason) {
    case 'visit':
      return 'visitingFriend';
    case 'locked':
      return undefined;
    case 'dead':
      return reason;
    default:
      assertNever(reason);
  }
}
